module.exports = __webpack_public_path__ + "static/media/lockIconGrey.91889524.svg";